import { Component, Inject } from '@angular/core';
import { NetworkStatusService } from '../../_services/network-status.service';
import { EVC_MODAL_REF, type ModalRef } from "../../_shared/services/modal/evc-modal.service";

@Component({
    selector: 'app-license-agreement-dialog',
    templateUrl: './license-agreement-dialog.component.html',
    styleUrls: ['./license-agreement-dialog.component.scss'],
    standalone: false
})
export class LicenseAgreementDialogComponent {

  public get isOnPremiseMode(): boolean {
    return this.networkStatusService.isOnPremise;
  }

  constructor(
    @Inject(EVC_MODAL_REF) private modalRef: ModalRef<any>,
    private networkStatusService: NetworkStatusService
  ) { }

  close() {
    this.modalRef.close();
  }
}
